import React from 'react'
import './style/footer.css'

const Footer = () => {
    const nowDate = new Date()
    return (
        <footer>
            Created by Tal Rozman © 2024-{nowDate.getFullYear()} - All rights reserved
        </footer>
    )
}

export default Footer